import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './authModalWindow.scss';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import { userSlice } from 'store/slices/userSlice';
import { useCallback, useEffect } from 'react';
import { TELEGRAM_BOT_URL } from 'constants/globalConstants';

const MySwal = withReactContent(Swal);

const AuthModalWindow = () => {
  const { auth, logout } = userSlice.actions;
  const dispatch = useAppDispatch();
  const { tryPlayWithoutAuth } = userSlice.actions;
  const { loggedIn, tryPlayWithoutAuth: localTryPlayWithoutAuth } =
    useAppSelector((state) => state.user);

  const handleLogout = useCallback(() => {
    dispatch(logout());
    Swal.fire({
      icon: 'success',
      title: 'Успешно!',
      text: 'Вы успешно вышли из системы!',
    });
  }, [dispatch, logout]);

  const handleLoginModal = useCallback(() => {
    dispatch(tryPlayWithoutAuth(false));
    MySwal.fire({
      title: 'Авторизация',
      html: `
      <form id="login-form" class="swal2-form">
        <div class="swal2-input-group">
          <input type="text" id="login" class="swal2-input" placeholder="Логин" form="login-form" autocomplete="username">
        </div>
        <div class="swal2-input-group">
          <input type="password" id="password" class="swal2-input" placeholder="Пароль" form="login-form" autocomplete="current-password">
        </div>
      </form>
      <div style="margin-top: 10px;">Если нет логина и пароля, перейдите в 
        <div style="margin-top: 10px;">
          <a href="${TELEGRAM_BOT_URL}" target="_blank" rel="noopener noreferrer" class="telegram-link-button">
            <span class="tg-emoji">✈️</span> Telegram бот
          </a>
        </div>
      </div>
    `,
      showCancelButton: true,
      confirmButtonText: 'Войти',
      cancelButtonText: 'Отмена',
      allowOutsideClick: () => !Swal.isLoading(),
      didOpen: () => {
        const form = Swal.getPopup()?.querySelector('#login-form');
        if (form) {
          form.addEventListener('submit', (e) => {
            e.preventDefault();
            Swal.clickConfirm();
          });
        }
      },
      preConfirm: async () => {
        const loginElement = Swal.getPopup()?.querySelector(
          '#login',
        ) as HTMLInputElement | null;
        const passwordElement = Swal.getPopup()?.querySelector(
          '#password',
        ) as HTMLInputElement | null;

        if (loginElement && passwordElement) {
          const login = loginElement.value;
          const password = passwordElement.value;

          if (!login || !password) {
            Swal.showValidationMessage('Введите логин и пароль');
            return false; // Останавливаем выполнение при отсутствии данных
          }

          try {
            const response = await fetch('/auth', {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                login,
                password,
              },
            });

            if (!response.ok) {
              Swal.showValidationMessage('Неверный логин или пароль');
              return false;
            }

            const data = await response.json();
            const token = data.data.token || null;

            if (!token) {
              Swal.showValidationMessage('Неверный логин или пароль');
              return false;
            }
            dispatch(auth(data.data.token));

            return true; // Возвращаем успех, если токен получен
          } catch (error) {
            Swal.showValidationMessage('Ошибка авторизации');
            return false; // Возвращаем ошибку при запросе
          }
        }
        Swal.showValidationMessage('Введите логин и пароль');
        return false; // Останавливаем выполнение при отсутствии данных
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          icon: 'success',
          title: 'Успешно!',
          text: 'Вы успешно вошли в систему!',
        });
      }
    });
  }, [auth, dispatch, tryPlayWithoutAuth]);

  useEffect(() => {
    if (localTryPlayWithoutAuth) handleLoginModal();
  }, [handleLoginModal, localTryPlayWithoutAuth]);

  return (
    <div className="authModalWindow">
      {loggedIn ? (
        <button type="button" onClick={handleLogout}>
          Выйти
        </button>
      ) : (
        <button type="button" onClick={handleLoginModal}>
          Войти
        </button>
      )}
    </div>
  );
};

export default AuthModalWindow;
